import React, {Component} from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "../../../../components/Table";
import CourseTypeAdd from "./add";
import Swal from "sweetalert2";
import {makeRequest} from "../../../../helpers/network_utils";
import {DELETE_REQUEST, GET_REQUEST} from "../../../../values/globals";
import endpoints from "../../../../routes/endpoints";
import {parseErrorResponse, showAlert} from "../../../../helpers/helper_functions";

const $ = window.$;

let self;
const columns = [
    {
        dataField: 'id',
        text: 'ID',
        //  formatter: row => `${row.first_name} ${row.last_name}`
    },
    {
        dataField: 'name',
        text: 'Name',
        //  formatter: row => `${row.first_name} ${row.last_name}`
    },
    {
        dataField: 'idd',
        text: 'Action',
        formatter: (id, row) => <button onClick={() => self.handleEditBranch(row)}
                                        className="btn btn-sm btn-primary">
            Edit
        </button>

    },
    {
        dataField: 'idd',
        text: 'Action',
        formatter: (id, row) => <button disabled={self.state.loadingDelete}
                                        onClick={() => self.handleDeleteCourse(row.id)}
                                        className="btn btn-sm btn-danger">
            {self.state.loadingDelete ? "Loading" : "Delete"}
        </button>

    },
]


class ExamTypes extends Component {
    state = {};

    componentDidMount() {
        self = this;
        this.getExamTypes();
    }

    handleAddCourse = e => {
        e.preventDefault();
        this.setState({
            exam_type: null
        }, () => $('#addExamTypeModal').modal('show'));
    }

    handleEditBranch = (exam_type) => {
        this.setState({
            exam_type: exam_type
        }, () => $('#addExamTypeModal').modal('show'));

    }

    handleDeleteCourse = (id) => {
        Swal.fire({
            title: "Confirm Delete",
            text: `Are you sure you want to delete this exam type?`,
            icon: "info",
            showConfirmButton: true,
            showCancelButton: true
        }).then(result => {
            if (result.isConfirmed) {

                this.setState({
                    loadingDelete: true
                })
                makeRequest(DELETE_REQUEST, `${endpoints.exam_types}${id}/`, {}, () => {
                    Swal.fire(
                        'Success!',
                        `Exam type was deleted successfully!`,
                        'success'
                    ).then(() => {
                        this.getExamTypes();
                    });
                }, (error) => {
                    showAlert('error', 'Error', parseErrorResponse(error));
                }, () => {
                    this.setState({loadingDelete: false})
                }).then()
            }
        })
    }

    getExamTypes = () => {
        this.setState({loading: true});
        makeRequest(GET_REQUEST, `${endpoints.exam_types}`, {}, response => {
            this.setState({exam_types: response.data});
        }, (error) => {
            showAlert('error', 'Error', parseErrorResponse(error));
        }, () => {
            this.setState({loading: false})
        }).then()
    }

    render() {
        const {loading, exam_types, exam_type} = this.state;
        return (loading ?
                <div className="text-center">
                    <CircularProgress/>
                </div> :
                <div>
                    <CourseTypeAdd exam_type={exam_type} key={Math.random()}
                                   getExamTypes={this.getExamTypes}/>
                    <Table
                        caption={"Exam Types"}
                        actionText={"Add Exam Type"}
                        columns={columns}
                        actionFunc={this.handleAddCourse}
                        data={exam_types}
                    />
                </div>
        );
    }
}

export default ExamTypes;